import React from "react"
import Showcase from "./Showcase"
import type { ShowcaseItem } from '../data/db/database'

interface ShowcaseViewProps {
  components: ShowcaseItem[]
}

const ShowcaseView: React.FC<ShowcaseViewProps> = ({ components }) => {
  return (
    <div className="row mt-30-reverse">
      {components.map((component) => (
        <div className="col-lg-6 col-md-6 col-12 mt-30" key={component.id}>
          <Showcase data={component} />
        </div>
      ))}
    </div>
  )
}

export default ShowcaseView
